<template>
  <div id="header" class="header">
    <!-- 进度条 -->
    <div id="pre" :style="{ width: widthPre + '%' }" />
    <!-- 内容 -->
    <div class="content">
      <div class="logo-wrap">
        <!-- logo -->
        <a href="/" class="logo">
          <img :src="$store.state.webSiteInfo.logo" />
        </a>
        <!-- 手机端导航栏 -->
        <span
          v-if="isMobile"
          style="
            position: absolute;
            top: 25%;
            left: 10px;
            color: var(--theme-color);
          "
        >
          <a @click="openDrawer" style="font-size: 20px">
            <i class="fas fa-bars" style="font-size: 1.5rem" />
          </a>
        </span>
        <!-- 手机端搜索栏 -->
        <span
          v-if="isMobile"
          style="
            position: absolute;
            top: 25%;
            right: 10px;
            color: var(--theme-color);
          "
        >
          <a @click="openSearchDrawer" style="font-size: 20px">
            <i class="fas fa-search" style="font-size: 1.5rem" />
          </a>
        </span>
      </div>

      <!-- 菜单栏 -->
      <nav>
        <a href="/" :class="['item', path === '/' ? 'active' : '']">
          <i class="fas fa-home" style="color: #409EFF;"></i>首页
        </a>
        <router-link :to="{ path: '/updatenotes' }" :class="['item', path === '/updatenotes' ? 'active' : '']">
          <i class="fas fa-history" style="color: #67C23A;"></i> 
          更新日志
        </router-link>
        <router-link :to="{ path: '/workshop' }" :class="['item2', path === '/workshop' ? 'active' : '']">
          <i class="fas fa-paint-brush" style="color: #E6A23C;"></i>
           创意工坊
        </router-link>
        <router-link :to="{ path: '/case' }" :class="['item2', path === '/case' ? 'active' : '']">
          <i class="fas fa-box-open" style="color: #F56C6C;"></i> 
          武器箱/大行动
        </router-link>
        <router-link :to="{ path: '/command' }" :class="['item2', path === '/command' ? 'active' : '']">
          <i class="fas fa-code" style="color: #909399;"></i> 
          CS2指令大全
        </router-link>
        <router-link :to="{ path: '/valvestandings' }" :class="['item3', path === '/valvestandings' ? 'active' : '']">
          <i class="fas fa-trophy" style="color: #FFD700;"></i> 
          V社战队排名
        </router-link>
        <router-link :to="{ path: '/sites' }" :class="['item', path === '/sites' ? 'active' : '']">
          <i class="fas fa-compass" style="color: #9B59B6;"></i> 
          CS导航大全  
        </router-link>
        <router-link :to="{ path: '/about' }" :class="['item', path === '/about' ? 'active' : '']">
          <i class="fas fa-user" style="color: #3498DB;"></i> 
          关于作者
        </router-link>
      </nav>
      <div class="header-actions">
        <!-- 用户菜单（桌面端在搜索左侧） -->
        <div class="user-menu">
          <!-- 未登录状态 -->
          <div v-if="!user" class="auth-buttons">
            <a class="login-btn" @click="handleLogin">
              <i class="fas fa-sign-in-alt"></i> 登录
            </a>
            <!-- <a class="register-btn" @click="openRegister">
            <i class="fas fa-user-plus"></i> 注册
          </a> -->
          </div>
          <!-- 已登录状态 -->
          <div v-else class="user-info">
            <router-link :to="{ path: '/user' }" class="user-link">
              <img v-if="user.avatar" :src="user.avatar" :alt="user.nickname" class="user-avatar" />
              <span v-else class="user-avatar-text">{{ user.nickname }}</span>
              <span class="user-nickname">{{ user.nickname }}</span>
            </router-link>
            <a class="logout-btn" @click="logout" title="退出登录">
              <i class="fas fa-sign-out-alt"></i>
            </a>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="search">
          <input
            @focus="focus"
            @blur="blur"
            class="searchInput"
            type="text"
            v-model="keywords"
            placeholder="请输入关键字..."
          />
          <a class="commit" href="javascript:;" @click="search()">
            <i class="fas fa-search"></i>
          </a>
          <!-- 热搜框 -->
          <div class="hot_search_main" :style="style">
            <a
              :href="'/articleInfo?articleId=' + item.id"
              v-for="(item, index) in $store.state.hotArticles"
              :key="index"
            >
              <span :style="{ backgroundColor: `${colors[index]}` }">{{
                index + 1
              }}</span>
              {{ item.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { logout } from "@/api";
import { removeUser } from "@/utils/auth";
export default {
  name: "Header",
  data() {
    return {
      dialog: false,
      widthPre: "",
      keywords: null,
      style: null,
      path: null,
      isMobile: false,
      windowWidth: 0,
      adminUrl: process.env.VUE_APP_ADMIN_API,
      colors: ["#FE2D46", "#FF6600", "#FAA90E", "#7f7f8c", "#7f7f8c"],
      logo: "https://cdn.cs2club.cn/images/logo.jpg",
      imgUrl:
        "data:image/png;base64,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",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getWindowWidth();
    const bc = new BroadcastChannel("my-channel");
    bc.onmessage = (event) => {
      const { userValue } = event.data;
      if (!userValue) {
        return;
      }
      const currentValue = JSON.stringify(this.$store.state.user || {});
      if (userValue !== currentValue) {
        try {
          this.$store.commit('login', JSON.parse(userValue));
        } catch (e) {
          console.error('BroadcastChannel parse userValue failed', e);
        }
      }
    };
    // 正确设置窗口resize事件监听
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
    window.addEventListener("scroll", this.scrollFn, false);
  },

  created() {},
  watch: {
    $route(newName, oldName) {
      this.path = newName.path;
    },
    // 监听页面宽度
    windowWidth(val) {
      this.isMobile = val < 891;
    },
  },

  methods: {
    getWindowWidth() {
      this.windowWidth = window.innerWidth; // 获取窗口宽度
    },

    handleClike() {
      this.$router.push({
        name: "/category",
        query: { id: "17", name: "后端框架" },
      });
    },
    handleClike(val) {
      window.location.href = val;
    },
    focus() {
      this.style =
        "transform:translate3d(0, 0, 0);opacity:1;visibility:visible";
    },
    blur() {
      this.style = "opacity:0;visibility:hidden";
    },
    search() {
      if (this.keywords == null || this.keywords == "") {
        this.$toast({ type: "warnning", message: "请输入搜索内容" });
        return;
      }
      this.$router.push({ path: "/search", query: { keyword: this.keywords } });
    },
    scrollFn() {
      let page = document.body.scrollHeight;
      let client = document.documentElement.clientHeight;
      let comend = page - client;
      let scrTop = document.documentElement.scrollTop;
      this.widthPre = Math.round((scrTop / comend) * 10000) / 100;

      // 页面滚动距顶部距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scroll = scrollTop - this.i;
      this.i = scrollTop;

      // 鼠标向上滚动
      if (scroll < 0) {
        document.getElementById("header").className = null;
        document.getElementById("header").className = "header slideDown";
      } else {
        document.getElementById("header").className = null;
        // 鼠标向下滚动
        document.getElementById("header").className = "header slideUp";
      }
    },
    handleLogin() {
      this.$store.commit("setLoginFlag", true); // 存储到vuex
    },
    openRegister() {
      this.$store.commit("setRegisterFlag", true); // 打开注册框
    },
    logout() {
      //如果在个人中心则跳回上一页
      if (this.path === "/user") {
        this.$router.go(-1);
      }
      logout()
        .then((res) => {
          removeUser();
          this.$store.commit('logout');
          this.$toast({ type: "success", message: "注销成功" });
          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          // 即使后端接口失败，也执行登出操作
          removeUser();
          this.$store.commit('logout');
          location.reload();
        });
    },
    openDrawer() {
      this.$store.commit("setDrawer", true);
    },
    openSearchDrawer() {
      this.$store.commit("setSearchDrawer", true);
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 890px) {
  /*针对宽度小于等于890px的屏幕设备，定义如下样式*/
  .header {
    width: 100%;
    z-index: 5;
    top: 0;

    nav,
    .search {
      display: none;
    }

    #pre {
      position: fixed;
      top: 0;
      height: 2px;
      background: linear-gradient(45deg, #3884d9 50%, #40d968);
      z-index: 10;
      width: 100%;
    }

    .content {
      z-index: 5;
      position: fixed;
      width: 100%;
      background-color: var(--header-back-color);
      backdrop-filter: blur(4px);
      display: flex;
      justify-content: center;

      .logo-wrap {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .logo {
        height: 60px;
        display: flex;
        align-items: center;
        position: relative;

        img {
          width: 60px;
          height: 50px;
          margin: 0 15px 0 10px;
        }
      }
    }
  }
}
.y-line {
  color: lightgrey;
}
@media screen and (min-width: 891px) {
  /*针对宽度大于等于891px的屏幕设备，定义如下样式*/
  .slideDown {
    transition: transform 0.5s ease-out;
    transform: translateY(0);
  }

  .slideUp {
    transition: transform 0.5s ease-out;
    transform: translateY(-100px);
  }

  .header {
    position: fixed;
    width: 100%;
    z-index: 5;
    top: 0;

    #pre {
      position: fixed;
      top: 0;
      height: 2px;
      background: linear-gradient(45deg, #3884d9 50%, #40d968);
      z-index: 10;
    }

    .content {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      background-color: var(--header-back-color);
      backdrop-filter: blur(4px);

      .logo-wrap {
        position: relative;
        flex-shrink: 0;
      }

      .header-actions {
        display: flex;
        align-items: center;
        margin-left: auto;
        flex-shrink: 0;
        gap: 16px;
        padding-right: 20px;
      }

      .logo {
        height: 60px;
        display: flex;
        align-items: center;
        // margin-left: 20px;
        position: relative;

        &::after {
          content: "";
          border-right: 1px solid #ebeef5;
          position: absolute;
          right: 0;
          width: 20px;
          height: 20px;
        }

        img {
          // width: 60px;
          height: 50px;
          margin: 0 15px 0 10px;
        }
      }
    }
  }

  nav {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;

    svg {
      width: 30px;
      height: 30px;
    }

    .active {
      text-decoration: none;
      font-size: 15px;
      transition: color 0.35s;
      line-height: 60px;
      height: 60px;
      display: flex;
      color: var(--header-text-color);
      position: relative;
      justify-content: center;
      width: 90px;
      white-space: nowrap;
      transition: color 0.35s;
      padding: 0 8px;
      margin-right: 20px;

      i {
        font-weight: 700;
        display: inline-block;
        margin-right: 5px;
        font-size: 18px;
    
      }

      &::after {
        content: "";
        height: 4px;
        overflow: hidden;
        display: block;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        width: 50%;
        background: var(--theme-color);
        margin: auto;
      }
    }

    .item1 {
      text-decoration: none;
      font-size: 18px;
      transition: color 0.35s;
      line-height: 60px;
      height: 30px;
      display: flex;
      color: var(--header-text-color);
      position: relative;
      justify-content: center;
      width: 90px;
      white-space: nowrap;
      transition: color 0.35s;
      padding: 0 8px;
      margin-right: 20px;
      margin-left: 5px;
    }

    .item, .item2, .item3 {
      text-decoration: none;
      font-size: 18px;
      transition: all 0.35s ease;
      line-height: 60px;
      height: 60px;
      display: flex;
      color: var(--header-text-color);
      position: relative;
      justify-content: center;
      white-space: nowrap;
      padding: 0 15px;
      margin: 0 5px;
      border-radius: 4px;
      min-width: 90px;

      i {
        font-weight: 700;
        display: inline-block;
        margin-right: 5px;
        font-size: 18px;
      }

      &.active {
        color: var(--theme-color);
      }

      &:hover {
        color: var(--theme-color);
        background-color: rgba(var(--theme-color-rgb), 0.1);
        
        i {
          animation: shock 0.1s linear 3;
        }

        &::after {
          width: 30px;
        }
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 3px;
        background: var(--theme-color);
        transition: all 0.35s ease;
        transform: translateX(-50%);
      }
    }

    .item2, .item3 {
      min-width: 110px;
    }

    .article .menus-submenu {
      height: 120px;
    }

    .menu-item {
      position: relative;
      padding: 0;

      &:hover .menus-submenu {
        display: block;
      }

      .user-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }

      .menus-submenu {
        position: absolute;
        display: none;
        right: 0;
        top: 60px;
        left: -20px;
        width: max-content;
        box-shadow: 0 5px 20px -4px rgba(0, 0, 0, 0.5);
        background-color: var(--background-color);
        animation: submenu 0.3s 0.1s ease both;
        list-style: none;

        &:before {
          position: absolute;
          top: -8px;
          left: 0;
          width: 100%;
          height: 10px;
          content: "";
        }

        span {
          width: 130px;
          display: block;
          cursor: pointer;
          color: var(--text-color);
          text-shadow: none;
          text-align: center;
          height: 40px;
          line-height: 40px;
          font-weight: 700;

          i {
            line-height: 40px;
          }

          &:hover {
            background-color: var(--theme-color);
            color: white;
          }
        }
      }

      @keyframes submenu {
        0% {
          opacity: 0;
          filter: alpha(opacity=0);
          transform: translateY(10px);
        }

        100% {
          opacity: 1;
          filter: none;
          transform: translateY(0);
        }
      }
    }

    .user {
      .menus-submenu {
        top: 50px;
        height: 80px;
        left: -40px;
      }
    }
  }

  @keyframes shock {
    0% {
      margin-top: 0px;
    }

    100% {
      margin-top: 2px;
      /* 可以自定义上下左右的幅度 */
    }
  }

  .search {
    display: flex;
    position: relative;
    flex-shrink: 0;
    z-index: 1;

    .searchInput {
      outline: 0;
      border: 0;
      border-radius: 30px;
      background-color: var(--search-input-background-color);
      width: 220px;
      height: 30px;
      padding: 0;
      padding-left: 10px;
      caret-color: var(--theme-color);
      border: 1px solid var(--search-input-background-color);
      color: var(--text-color);

      &:focus {
        border: 1px solid var(--theme-color);
        background-color: var(--background-color);
      }
    }

    .commit {
      position: absolute;
      top: 0px;
      right: 0px;
      height: 30px;
      width: 60px;
      background-color: var(--theme-color);
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      text-decoration: none;
      text-align: center;

      i {
        line-height: 33px;
        color: #fff;
      }
    }

    .hot_search_main {
      background-color: var(--background-color);
      border-radius: 4px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      position: absolute;
      z-index: 2;
      top: 40px;
      left: 0;
      right: 0;
      opacity: 0;
      visibility: hidden;
      transition: visibility 0.35s, opacity 0.35s, transform 0.35s;
      transform: translate3d(0, 15px, 0);

      a {
        height: 40px;
        text-decoration: none;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /* border-bottom: 1px solid #f2f6fc; */
        line-height: 40px;
        padding: 4px 5px;
        color: #606266;
        font-size: 12px;

        span {
          width: 20px;
          height: 20px;
          display: inline-block;
          line-height: 21px;
          text-align: center;
          border-radius: 3px;
          color: var(--background-color);
        }

        &:first-child {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }

        &:last-child {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }

        &:hover {
          background-color: rgb(235, 238, 245);
        }
      }
    }
  }
}

nav {
  a {
    text-decoration: none;
    color: var(--text-color);
    padding: 0 15px;
    height: 60px;
    line-height: 60px;
    display: inline-block;
    position: relative;
    transition: all 0.3s;

    i {
      margin-right: 5px;
      vertical-align: middle;
      display: inline-block;
      line-height: 60px;
    }
  }
}

// 用户菜单样式
.user-menu {
  display: flex;
  align-items: center;
  height: 60px;
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  gap: 15px;

  .auth-buttons {
    display: flex;
    gap: 10px;
    align-items: center;

    .login-btn,
    .register-btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
      border-radius: 4px;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: 500;
      height: 36px;
      line-height: 20px;

      i {
        font-size: 16px;
      }
    }

    .login-btn {
      color: var(--theme-color);
      border: 1px solid var(--theme-color);
      background-color: transparent;

      &:hover {
        background-color: rgba(var(--theme-color-rgb), 0.1);
        opacity: 0.8;
      }
    }

    .register-btn {
      color: #fff;
      background-color: var(--theme-color);

      &:hover {
        opacity: 0.85;
        box-shadow: 0 2px 8px rgba(var(--theme-color-rgb), 0.35);
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .user-link {
      display: flex;
      align-items: center;
      gap: 8px;
      text-decoration: none;
      color: var(--text-color);
      transition: all 0.3s ease;
      padding: 4px 8px;
      border-radius: 4px;

      &:hover {
        color: var(--theme-color);
        background-color: rgba(var(--theme-color-rgb), 0.1);
      }

      .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid var(--theme-color);
      }

      .user-avatar-text {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: var(--theme-color);
        color: white;
        font-size: 12px;
        font-weight: 600;
      }

      .user-nickname {
        font-size: 14px;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .logout-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: rgba(var(--theme-color-rgb), 0.1);
      color: var(--theme-color);
      cursor: pointer;
      transition: all 0.3s ease;
      text-decoration: none;
      font-size: 16px;

      &:hover {
        background-color: var(--theme-color);
        color: white;
        transform: scale(1.1);
      }
    }
  }
}

@media screen and (max-width: 890px) {
  .user-menu {
    position: absolute;
    right: 55px;
    top: 12px;
    height: auto;
    padding: 0;
    gap: 10px;

    .auth-buttons {
      flex-direction: column;
      gap: 6px;

      .login-btn,
      .register-btn {
        padding: 6px 12px;
        font-size: 12px;
        height: 30px;
        line-height: 18px;
      }
    }

    .user-info {
      gap: 6px;

      .user-link {
        padding: 2px 4px;
        gap: 4px;

        .user-avatar,
        .user-avatar-text {
          width: 28px;
          height: 28px;
        }

        .user-nickname {
          display: none;
        }
      }

      .logout-btn {
        width: 28px;
        height: 28px;
        font-size: 14px;
      }
    }
  }
}
</style>